import { render } from "./ParallaxHome.vue?vue&type=template&id=ee89a3f2"
import script from "./ParallaxHome.vue?vue&type=script&lang=js"
export * from "./ParallaxHome.vue?vue&type=script&lang=js"

import "./ParallaxHome.vue?vue&type=style&index=0&id=ee89a3f2&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__